/**
 * Session Controls Component
 * Start/End session buttons for therapist
 * Phase 7.1 - Session Management System
 */
import React from 'react';
/**
 * SessionControls Component
 * Provides buttons for therapist to start and end clinical sessions
 */
export default function SessionControls({ sessionState, onStartSession, onEndSession, disabled = false }) {
    const isWaiting = sessionState === 'waiting';
    const isActive = sessionState === 'active';
    const isEnded = sessionState === 'ended';
    return (React.createElement("div", { style: styles.container },
        React.createElement("div", { style: styles.label }, "Session Control"),
        isWaiting && (React.createElement("button", { style: { ...styles.button, ...styles.startButton }, onClick: onStartSession, disabled: disabled },
            React.createElement("span", { style: styles.buttonIcon }, "\u25B6"),
            "Start Session Recording")),
        isActive && (React.createElement("button", { style: { ...styles.button, ...styles.endButton }, onClick: onEndSession, disabled: disabled },
            React.createElement("span", { style: styles.buttonIcon }, "\u23F9"),
            "End Session")),
        isEnded && (React.createElement("div", { style: styles.endedMessage }, "Session Ended")),
        React.createElement("div", { style: styles.stateIndicator },
            React.createElement("span", { style: getStateIndicatorStyle(sessionState) }, "\u25CF"),
            ' ',
            sessionState.charAt(0).toUpperCase() + sessionState.slice(1))));
}
function getStateIndicatorStyle(state) {
    const baseStyle = { fontSize: '12px', marginRight: '4px' };
    switch (state) {
        case 'waiting':
            return { ...baseStyle, color: '#FFC107' };
        case 'active':
            return { ...baseStyle, color: '#4CAF50' };
        case 'ended':
            return { ...baseStyle, color: '#999' };
        default:
            return baseStyle;
    }
}
const styles = {
    container: {
        padding: '16px',
        backgroundColor: '#2b2b2b',
        borderRadius: '8px',
        minWidth: '250px'
    },
    label: {
        fontSize: '12px',
        color: '#999',
        marginBottom: '12px',
        textTransform: 'uppercase',
        letterSpacing: '1px'
    },
    button: {
        width: '100%',
        padding: '12px 16px',
        fontSize: '14px',
        fontWeight: '600',
        border: 'none',
        borderRadius: '6px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 0.2s',
        marginBottom: '12px'
    },
    startButton: {
        backgroundColor: '#4CAF50',
        color: 'white',
        ':hover': {
            backgroundColor: '#45a049'
        }
    },
    endButton: {
        backgroundColor: '#f44336',
        color: 'white',
        ':hover': {
            backgroundColor: '#da190b'
        }
    },
    buttonIcon: {
        marginRight: '8px',
        fontSize: '16px'
    },
    stateIndicator: {
        fontSize: '13px',
        color: '#ccc',
        textAlign: 'center'
    },
    endedMessage: {
        padding: '12px',
        textAlign: 'center',
        color: '#999',
        fontStyle: 'italic',
        marginBottom: '12px'
    }
};
